<template>
  <div class="login-page">
    <Toast />
    <div class="login-card">
      <div class="login-header">
        <img
          src="../assets/icon_company.png"
          alt="Logo"
          class="login-logo"
        />
      </div>

      <form name="form" @submit.prevent="handleLogin" class="login-form">
        <div class="login-field">
          <label for="username">Username</label>
          <span class="p-input-icon-left login-input-wrapper">
            <i class="pi pi-user"></i>
            <InputText
              id="username"
              v-model="user.username"
              v-validate="'required'"
              type="text"
              :class="{ 'p-invalid': errors.has('username') }"
              name="username"
              placeholder="Insira o seu username"
            />
          </span>
          <small v-if="errors.has('username')" class="p-error" role="alert">
            Username é obrigatório
          </small>
        </div>

        <div class="login-field">
          <label for="password">Password</label>
          <span class="p-input-icon-left login-input-wrapper">
            <i class="pi pi-lock"></i>
            <InputText
              id="password"
              v-model="user.password"
              v-validate="'required'"
              type="password"
              :class="{ 'p-invalid': errors.has('password') }"
              name="password"
              placeholder="Insira a sua password"
            />
          </span>
          <small v-if="errors.has('password')" class="p-error" role="alert">
            Password é obrigatório
          </small>
        </div>

        <Button
          label="Entrar"
          icon="pi pi-sign-in"
          class="login-button"
          type="submit"
          :loading="loading"
          :disabled="loading"
        />
      </form>

      <div class="login-footer">
        <span>&copy; {{ currentYear }} Intranet</span>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../models/user";

export default {
  name: "Login",
  data() {
    return {
      user: new User("", ""),
      loading: false,
      message: ""
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.loggedIn;
    },
    currentYear() {
      return new Date().getFullYear();
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/").catch(() => {});
    }
  },
  methods: {
    handleLogin() {
      if (this.loading) return;
      this.$toast.removeAllGroups();
      this.loading = true;
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.loading = false;
          return;
        }

        if (this.user.username && this.user.password) {
          this.$store.dispatch("auth/login", this.user).then(
            () => {
              this.$router.push("/").catch(() => {});
            },
            error => {
              this.loading = false;
              this.message =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();

              this.$toast.add({
                severity: "error",
                summary: "Erro no Login",
                detail: "O username ou password estão incorretos",
              });
            }
          );
        }
      });
    }
  }
};
</script>

<style scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  padding: 1rem;
}

.login-card {
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow:
    0 4px 6px rgba(0, 0, 0, 0.04),
    0 10px 40px rgba(0, 0, 0, 0.08);
  padding: 2.5rem 2.5rem 2rem;
  animation: cardFadeIn 0.5s ease-out;
}

@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-logo {
  width: 102px;
  height: 102px;
  -o-object-fit: contain;
  object-fit: contain;
  margin-bottom: 0.5rem;
}

.login-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 0.375rem;
  letter-spacing: -0.02em;
}

.login-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.login-field label {
  display: block;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}

.login-input-wrapper {
  display: block;
  width: 100%;
}

.login-input-wrapper .p-inputtext {
  width: 100%;
  padding: 0.75rem 0.75rem 0.75rem 2.5rem;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  font-size: 0.9375rem;
  color: #1a1a2e;
  background: #fafafa;
  transition: all 0.2s ease;
}

.login-input-wrapper .p-inputtext::placeholder {
  color: #9ca3af;
}

.login-input-wrapper .p-inputtext:focus {
  outline: none;
  border-color: #1a1a2e;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(26, 26, 46, 0.08);
}

.login-input-wrapper .p-inputtext.p-invalid {
  border-color: #ef4444;
}

.login-input-wrapper .p-inputtext.p-invalid:focus {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.login-input-wrapper > i {
  left: 0.875rem;
  color: #9ca3af;
  font-size: 0.9375rem;
  transition: color 0.2s ease;
}

.login-input-wrapper:focus-within > i {
  color: #1a1a2e;
}

.login-field .p-error {
  font-size: 0.75rem;
  margin-top: 0.375rem;
  color: #ef4444;
}

.login-button {
  width: 100%;
  padding: 0.8rem 1.5rem;
  margin-top: 0.5rem;
  border: none;
  border-radius: 10px;
  font-size: 0.9375rem;
  font-weight: 600;
  background: #1a1a2e;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
  justify-content: center;
}

.login-button:enabled:hover {
  background: #16213e;
  box-shadow: 0 4px 12px rgba(26, 26, 46, 0.3);
  transform: translateY(-1px);
}

.login-button:enabled:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(26, 26, 46, 0.2);
}

.login-footer {
  text-align: center;
  margin-top: 2rem;
  padding-top: 1.25rem;
  border-top: 1px solid #f3f4f6;
}

.login-footer span {
  font-size: 0.75rem;
  color: #9ca3af;
}
</style>
